export const IS_LOGGED_IN_KEY =
  'OIOuhojhjkKKiuyu79782FsdGVkX19oY9rga77TjRbFdaQ4';
export const CURRENT_PROFILE_DETAILS =
  'JIOhioFrtfjopjiopU2FsdGVkX1+i0MzSAHlsJNyGXOYsPFDRWM228+Wn43Q=';

export const USER_DEFAULT_PASSWORD = 'us3r_p@55w0rd';

export const TOAST_CHANGE_PASSWORD = 'Change password';
export const TOAST_USER_UPDATE = 'User update';
